import { defineMessages } from 'react-intl'

export default defineMessages({
  pageTitle: {
    id: 'containers.PublicMemorySharingPage.pageTitle',
    defaultMessage: 'Pronunciations',
  },
  intro: {
    id: 'containers.PublicMemorySharingPage.intro',
    defaultMessage: 'Hi! We shared these pronunciations with you. Use the play button next to each word to listen. Enjoy!',
  },
  noRecordings: {
    id: 'containers.PublicMemorySharingPage.noRecordings',
    defaultMessage: 'No recordings available yet.',
  },
  notFound: {
    id: 'containers.PublicMemorySharingPage.notFound',
    defaultMessage: 'Not found',
  },
  playTitle: {
    id: 'containers.PublicMemorySharingPage.playTitle',
    defaultMessage: 'Play',
  },
  stopTitle: {
    id: 'containers.PublicMemorySharingPage.stopTitle',
    defaultMessage: 'Stop',
  },
  noText: {
    id: 'containers.PublicMemorySharingPage.noText',
    defaultMessage: 'No text',
  },
  countChip: {
    id: 'containers.PublicMemorySharingPage.countChip',
    defaultMessage: '{count, plural, one {# pronunciation} other {# pronunciations}}',
  },
  downloadTitle: {
    id: 'containers.PublicMemorySharingPage.downloadTitle',
    defaultMessage: 'Download',
  },
})
